/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { styled } from '@leagueplatform/genesis-core';
import { NavLink, NavLinkProps } from 'react-router-dom';

export const StyledNavLink = styled(NavLink, {
  display: 'flex',
  position: 'relative',
  alignItems: 'center',
  color: '$onSurfaceTextSubdued',
  typography: '$buttonTwo',
  textDecoration: 'none !important',
  cursor: 'pointer',
  justifyContent: 'center',
  fontWeight: 'bold',
  padding: '$none $half',
  '&:hover': {
    color: '$onSurfaceTextPrimary',
  },
  '&[aria-current="page"]': {
    color: '$onSurfaceTextPrimary',
  },
  '&[aria-current="page"]:after': {
    content: '""',
    display: 'block',
    position: 'absolute',
    bottom: -1,
    insetInlineStart: 0,
    backgroundColor: '$interactiveActionPrimary',
    height: '$quarter',
    borderRadius: '$large',
    width: '100%',
  },
});

export const HeaderNavItem = styled('li', {
  display: 'flex',
  alignSelf: 'stretch',
});

type HeaderNavLinkProps = NavLinkProps;
export const HeaderNavLink = (props: HeaderNavLinkProps) => (
  <HeaderNavItem>
    <StyledNavLink {...props} />
  </HeaderNavItem>
);
